import { render, staticRenderFns } from "./commission-list.vue?vue&type=template&id=7cdda225"
import script from "./commission-list.vue?vue&type=script&lang=ts"
export * from "./commission-list.vue?vue&type=script&lang=ts"
import style0 from "./commission-list.vue?vue&type=style&index=0&id=7cdda225&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports